export default __webpack_public_path__ + "static/media/playstore.4432ae59.svg";